export default __webpack_public_path__ + "static/media/022-brazil.32f11562.svg";